import {StrictMode, useEffect} from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './translations/i18n.tsx'
import {QueryClientProvider} from '@tanstack/react-query'
import {queryClient} from '@/queryClient.ts'
import {envVars} from '@/envVars.ts'
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router-dom'
import TagManager from 'react-gtm-module'
import {init, reactRouterV6BrowserTracingIntegration, replayIntegration} from '@sentry/react'
import '@/index.css'

if (envVars.VITE_GTM_ID && import.meta.env.MODE === 'production') {
    TagManager.initialize({gtmId: envVars.VITE_GTM_ID})
}
if (envVars.VITE_SENTRY_DSN) {
    init({
        dsn: envVars.VITE_SENTRY_DSN,
        integrations: [
            reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            }),
            replayIntegration()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['https://navigate.translated.com/'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    })
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </StrictMode>
)
